import img_1 from "./../img/action/photo_pc.jpg";
import img_2 from "./../img/slider/72.jpg";
import img_3 from "./../img/slider/36.jpg";
import img_4 from "./../img/slider/27.jpg";
import img_5 from "./../img/slider/15.jpg";
import img_6 from "./../img/slider/1.jpg";
import img_7 from "./../img/slider/49.jpg";

const sliderData = [
  {
    label: `A single portrait or a family session surrounded by Christmas decorations.`,
    title: 'Christmas Magic',
    img: img_1
  },
  {
    label: `A single portrait or a family session surrounded by Christmas decorations.`,
    title: 'Christmas Magic',
    img: img_2
  },
  {
    label: 'A single portrait or a family session surrounded by Christmas decorations.',
    title: 'Christmas Magic',
    img: img_3
  },
  {
    label: 'A single portrait or a family session surrounded by Christmas decorations.',
    title: 'Christmas Magic',
    img: img_4
  },
  {
    label: 'A single portrait or a family session surrounded by Christmas decorations.',
    title: 'Christmas Magic ',
    img: img_5
  },
  {
    label: 'A single portrait or a family session surrounded by Christmas decorations.',
    title: `Christmas Magic`,
    img: img_6
  },
  {
    label: 'A single portrait or a family session surrounded by Christmas decorations.',
    title: `Christmas Magic`,
    img: img_7
  },
]

export {sliderData};